export class Parent {
    constructor(arr = [], _key) {
        this.$$_list = arr
        arr = arr || []
        arr.forEach(item => {
            const key = item[_key]
            this[key] = item
        })
    }
}

